<template>
  <div id="SAE">
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane name="Deposit">
        <template #label>
          <span class="custom-tabs-label">
            <span> {{ messages.topupH[store.langSelect.value] }}</span>
          </span>
        </template>
        <div style="margin-top: 40px">
          <Deposit v-if="activeName == 'Deposit'"></Deposit>
        </div>
      </el-tab-pane>
       <el-tab-pane name="Transfer" v-if="Object.keys(store.AccountsFullData).length>1">
        <template #label>          
          <span class="custom-tabs-label">
            <span>{{ messages.transferH[store.langSelect.value] }}</span>
          </span>
        </template>
        <div style="margin-top: 40px"> 
          <Transfer v-if="activeName == 'Transfer'" />
        </div>
      </el-tab-pane> 
      <el-tab-pane name="fundsTransfer">
        <template #label>
          <span class="custom-tabs-label">
            <span>{{ messages.withdrawalH[store.langSelect.value] }}</span>
          </span>
        </template>
        <div style="margin-top: 40px"> 
          <Withdrawal v-if="activeName == 'fundsTransfer'" />
        </div>
      </el-tab-pane>
      <el-tab-pane name="DepositUDT">
        <template #label>
          <span class="custom-tabs-label">
            <span> {{ messages.DepositUDTH[store.langSelect.value] }}</span>
          </span>
        </template>
        <div style="margin-top: 40px">
          <DepositUDT v-if="activeName == 'DepositUDT'"></DepositUDT>
        </div>
      </el-tab-pane> 
      <el-tab-pane name="conversion">
        <template #label>
          <span class="custom-tabs-label">
            <span>{{ messages.conversionH[store.langSelect.value] }}</span>
          </span>
        </template>
        <div style="margin-top: 40px">
          <Conversion v-if="activeName == 'conversion'" />
        </div>
      </el-tab-pane>
      <el-tab-pane name="SafetyRegulations">
        <template #label>
          <span class="custom-tabs-label">
            <span>
              {{ messages.safetyregulationsH[store.langSelect.value] }}</span
            >
          </span>
        </template>
        <div style="margin-top: 40px">
          <SafetyRegulations
            v-if="activeName == 'SafetyRegulations'"
          ></SafetyRegulations>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";
import { useMyStorage } from "@/store/global";
import { ElTabs, ElTabPane } from "element-plus";
import Conversion from "@/components/Conversion";
import Deposit from "@/components/Deposit";
import DepositUDT from "@/components/DepositUDT";
 import Transfer from "@/components/Transfer";
import Withdrawal from "@/components/Withdrawal";
import SafetyRegulations from "./SafetyRegulations";


export default defineComponent({
  name: "ServiceForAE",
  props: {},
  components: {
    ElTabs,
    ElTabPane,
    Deposit,
    DepositUDT,
    Conversion,
    Transfer,
    SafetyRegulations,
    Withdrawal
  },
  setup() {
    const store = useMyStorage();
    const activeName = ref("Deposit");
    const messages = {
      certificateH: [
        "Создание ключа для торгового терминала",
        "Generate a key for a trading terminal",
      ],
      certificatePasswordP: [
        "Желаемый пароль к терминалу (минимум 6 знаков)",
        "Password for the terminal (at least 6 characters)",
      ],
      certificatePasswordPC: ["Повторите пароль", "Confirm password"],
      downloadTerminal: [
        "Скачать торговый терминал",
        "Download trading terminal",
      ],
      certificateCreateB: ["Создать", "Generate"],
      certificateCreatedT: [
        "Файл сертификата успешно создан",
        "Certificate file created successfully",
      ],
      certificateCreatedB: ["Скачать сертификат", "Download certificate"],
      DepositUDTH:["Депо","USDT Deposit Token"],
      topupH: ["Ввод", "Top up account"],
      topupS: ["Выберите счет", "Select account"],
      topupNot: [
        "Не доступно в Game контуре биржи",
        "Not available in the Game",
      ],
      topupHistoryH: ["История депозита", "Deposit history"],
      topupHistoryD: ["Дата", "Date"],
      topupHistorySum: ["Сумма", "Sum"],
      topupHistoryC: ["Сумма", "Confirm"],
      topupHistoryS: ["Статус", "Status"],
      topupCreateAddrB: ["Создать новый адрес", "Create new address"],
      refreshB: ["Обновить", "Refresh"],
      withdrawalT: [
        "Заявка, поданная до 14:00 UTC, обрабатывается до конца дня. По заявке поданной после 14:00 UTC вывод средств производится на следующий день. AE не начисляет собственные комиссии за вывод средств",
        "Applications submitted before 14:00 UTC are processed by the end of the day. For applications submitted after 14:00 UTC, the withdrawal of funds is made the next day. AE does not charge its own withdrawal fees\n",
      ],
      withdrawalH: ["Вывод", "Withdrawal request"],
      withdrawalSel: ["Выберите счет", "Select account"],
      withdrawalSum: ["Сумма выводимых BTC", "The amount of BTC withdrawn"],
      withdrawalAddr: ["Адрес", "Address"],
      withdrawalB: ["Отправить", "Send"],
      transferH: ["Перевод", "Transfer"],

      conversionH: ["Обмен", "Exchange"],
      testsH: ["Тесты", ""],
      aeinfo: [
        "Оплата биржевой комиссии производится собственным токеном АЕ. Для проведения торговых операций требуется наличие на торговом счете клиента токена АЕ." +
          "Токен АЕ можно купить через биржевой стакан подав ордер на покупку, после совершения трейда в позициях по торговому счету появится токен АЕ.",
        "Payment for the exchange commission is made with our own AE token. To conduct trading operations, it is required to have an AE token on the client's trading account." +
          "The AE token can be bought through the order book by submitting a buy order; after the trade is completed, the AE token will appear in the positions on the trading account.",
      ],
      safetyregulationsH: ["Основные правила безопасности", ""],
      emailTitle: ["Наш ", ""],
      referralH: ["Партнёрская программа", "Affiliate program"],
    };

    const handleClick = (tab, event) => {
      console.log(tab, event);
      console.log(activeName.value);
      store.LoadAllHistory();
    };
    return {
      activeName,
      handleClick,
      messages,
      store,
    };
  },
});
</script>
